import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ShieldCheck, Archive, Layers } from 'lucide-react';
import TipsterTriptych from './TipsterTriptych';

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-white" data-testid="hero-section">
      <div className="absolute inset-0 pitch-lines" />
      <svg className="absolute -right-32 -top-24 w-[720px] h-[720px] text-royal/[0.07] hidden lg:block" viewBox="0 0 400 400" fill="none">
        <circle cx="200" cy="200" r="150" stroke="currentColor" strokeWidth="2" />
        <circle cx="200" cy="200" r="6" fill="currentColor" />
        <line x1="200" y1="0" x2="200" y2="400" stroke="currentColor" strokeWidth="2" />
      </svg>

      <div className="relative max-w-7xl mx-auto px-5 md:px-8 pt-16 md:pt-24 pb-20 md:pb-28 grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">
        <div className="lg:col-span-7">
          <div className="eyebrow text-royal rise">Three specialist tipsters · One standard</div>
          <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl xl:text-[72px] font-extrabold tracking-tight text-navy leading-[1.02] rise rise-1" data-testid="hero-headline">
            Three Tipsters.<br />
            <span className="text-royal">Three Formats.</span><br />
            One Selection a Day.
          </h1>
          <p className="mt-7 text-base md:text-lg text-slate-600 leading-relaxed max-w-xl rise rise-2">
            A Daily Double from <strong className="text-navy">Turkish Team</strong>, one Asian Handicap line from <strong className="text-navy">Asian Tips</strong>, one single at odds around 2.00 from <strong className="text-navy">24 BOX Tips</strong>. Each releases at most one selection per day. Every day is recorded — wins, losses and no-pick days alike.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3 rise rise-3">
            <Link to="/#pricing" className="btn-primary" data-testid="hero-cta-pricing">
              See tipsters & prices <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/results" className="btn-ghost" data-testid="hero-cta-results">
              Open the archives
            </Link>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-4 text-sm text-slate-600 rise rise-4">
            <div className="flex items-center gap-2"><Layers className="w-4 h-4 text-royal" /> Subscribe to one tipster or combine them</div>
            <div className="flex items-center gap-2"><Archive className="w-4 h-4 text-royal" /> Full archives, including losing days</div>
            <div className="flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-royal" /> No guarantees. No noise.</div>
          </div>
        </div>

        <div className="lg:col-span-5">
          <TipsterTriptych />
        </div>
      </div>
    </section>
  );
}
